export default __webpack_public_path__ + "static/media/1.573d1fce.jpg";